import { createSlice } from "@reduxjs/toolkit";

import { ContactAPI } from "../../services/contact";

const Contact = createSlice({
  name: "Contact",
  initialState: {
    contacts: [],
    oneContact: null,
    total: 0,
  },

  reducers: {
    setOneContact: (state, action) => {
      state.oneContact = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(ContactAPI.getAll.fulfilled, (state, action) => {
        const { total, contacts } = action.payload;

        state.contacts = contacts;
        state.total = total;
      })

      .addCase(ContactAPI.getOne.fulfilled, (state, action) => {
        state.oneContact = action.payload;
      });
  },
});

export const { setOneContact } = Contact.actions;

export default Contact;
